module.exports = __webpack_public_path__ + "src/images/memory-game.e24991eefe87b6ccbd5b94f87f6ecfc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/memory-game.png
// module id = 123
// module chunks = 0